import { createDirectus, rest, authentication } from "@directus/sdk";
import { getAccessToken as getIdGovToken } from "./idgov/client";

const DIRECTUS_URL = import.meta.env.VITE_DIRECTUS_URL;
const DEV_MODE = import.meta.env.VITE_DEV_MODE === "true";

if (!DIRECTUS_URL) {
  throw new Error("VITE_DIRECTUS_URL environment variable is required");
}

// Create the directus client
// In production: only use REST with ID.GOV.UA token injection
// In dev mode: also add authentication module for directus.login()
function createClient() {
  const base = createDirectus(DIRECTUS_URL)
    .with(rest({
      onRequest: (options) => {
        // In production, inject ID.GOV.UA token
        if (!DEV_MODE) {
          const token = getIdGovToken();
          if (token) {
            options.headers = {
              ...options.headers,
              Authorization: `Bearer ${token}`,
            };
          }
        }
        return options;
      },
    }));
  
  // Only add authentication in dev mode
  if (DEV_MODE) {
    return base.with(authentication("json"));
  }
  return base;
}

export const directus = createClient();

export function getAssetUrl(assetId: string): string {
  return `${DIRECTUS_URL}/assets/${assetId}`;
}

export { DIRECTUS_URL };
